import FormattedMessage from 'I18n/components/FormattedMessage';
import UsageTracker from '../../../utils/UsageTracker';
import { Button } from 'foundations-components/transitional/components/Button';
import { useMyPlaylistsParams } from '../../myPlaylists/myPlaylistsHooks';
import { useACNavigate } from 'academy-common-lib/hooks/useACNavigate';
import { getMyPlaylistsUrl } from '../../myPlaylists/myPlaylistsRouting';
import { CollapsedButtonsGroup } from '../../buttons/CollapsedButtonsGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MyPlaylistsButtonGroupFilter = ({
  appearsIn
}) => {
  const navigate = useACNavigate();
  const {
    tab: selectedTab
  } = useMyPlaylistsParams();
  const handleMyPlaylistsFilterChange = value => {
    UsageTracker.trackStandalone('Filter Interaction', {
      action: 'filter-selected',
      value,
      isDropdown: true,
      key: 'my-playlists-filter',
      appearsIn
    });
    navigate(getMyPlaylistsUrl({
      tab: value
    }));
  };
  return /*#__PURE__*/_jsxs(CollapsedButtonsGroup, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(Button, {
      active: selectedTab === 'all',
      onClick: () => handleMyPlaylistsFilterChange('all'),
      use: "tertiary-extra-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.topFilters.myPlaylistsType.all"
      })
    }), /*#__PURE__*/_jsx(Button, {
      active: selectedTab === 'assigned-to-me',
      onClick: () => handleMyPlaylistsFilterChange('assigned-to-me'),
      use: "tertiary-extra-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.topFilters.myPlaylistsType.assigned-to-me"
      })
    }), /*#__PURE__*/_jsx(Button, {
      active: selectedTab === 'created-by-me',
      onClick: () => handleMyPlaylistsFilterChange('created-by-me'),
      use: "tertiary-extra-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.topFilters.myPlaylistsType.created-by-me"
      })
    }), /*#__PURE__*/_jsx(Button, {
      active: selectedTab === 'saved',
      onClick: () => handleMyPlaylistsFilterChange('saved'),
      use: "tertiary-extra-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.topFilters.myPlaylistsType.saved"
      })
    }), /*#__PURE__*/_jsx(Button, {
      active: selectedTab === 'archived',
      onClick: () => handleMyPlaylistsFilterChange('archived'),
      use: "tertiary-extra-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.topFilters.myPlaylistsType.archived"
      })
    })]
  });
};